export const WHBABTEC_MAINTENANCE_MODE_ACTIVE = false;
